import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import StripeSuccessDialog from "./stripe/StripeSuccessDialog";
import {
  DialogIdentifiers,
  selectActiveDialog,
  selectPayload,
  selectScrollPosition,
  setScrollPosition
} from '@shared/store/dialog.duck';
import SignUpTermsDialog from "@shared/dialogs/SignUpTermsDialog";
import ChooseLocationDialog from '@shared/dialogs/choose-location-dialog/ChooseLocationDialog';
import CreateTagDialog from '@shared/dialogs/CreateTagDialog';
import { WhereaboutsModifiedDialog } from "@shared/dialogs/WhereaboutsModifiedDialog";
import StripeFailedDialog from "./stripe/StripeFailedDialog";
import { AddCustomWhereaboutsDialog } from '@shared/dialogs/custom-whereabouts-dialog/AddCustomWhereaboutsDialog';
import DeleteOfficeEntityDialog from "@features/desks/dialogs/DeleteOfficeEntityDialog";
import DeleteDeskEntityDialog from "@features/desks/dialogs/DeleteDeskEntityDialog";
import { AzureCalendarSyncDisabledDialog } from '@shared/dialogs/AzureCalendarSyncDisabledDialog';
import EditDeskDialog from "@features/desks/dialogs/EditDeskDialog";
import EditUsersInTagDialog from '@shared/dialogs/EditUsersInTagDialog';
import ManageFavouritesDialog from '@shared/dialogs/ManageFavouritesDialog';
import { WeeklyNotesDialog } from '@shared/dialogs/weekly-notes/WeeklyNotesDialog';
import { AzurePermissionsRequired } from '@shared/dialogs/AzurePermissionsRequired';
import { MeetingRoomBookingDialog } from "@features/meeting-rooms/pages/dialogs/MeetingRoomBookingDialog";
import { EditMeetingRoomBookingDialog } from "@features/meeting-rooms/pages/dialogs/EditMeetingRoomBookingDialog";
import { AdvanceMeetingRoomBookingDialog } from "@features/meeting-rooms/pages/dialogs/AdvanceMeetingRoomBookingDialog";
import { RepeatScheduleDialog } from '@shared/dialogs/repeat-schedule-dialog/RepeatScheduleDialog';
import { SavedWhereaboutsErrors } from '@shared/dialogs/saved-whereabouts-errors/SavedWhereaboutsErrors';
import AssignToOfficeDialog from "@features/settings/pages/manage-users-page-v2/dialogs/AssignToOfficeDialog";
import AssignToTeamDialog from "@features/settings/pages/manage-users-page-v2/dialogs/AssignToTeamDialog";
import AssignToWorkGroupDialog from "@features/settings/pages/manage-users-page-v2/dialogs/AssignToWorkGroupDialog";
import AddMultipleUsersDialog from '@shared/dialogs/AddMultipleUsersDialog';
import EditTagDialog from '@shared/dialogs/workgroup-dialogs/EditTagDialog';
import EditTagNameDialog from '@shared/dialogs/workgroup-dialogs/EditTagNameDialog';
import AddUserToWorkGroupsDialog from '@shared/dialogs/workgroup-dialogs/AddUserToWorkGroupsDialog';
import { AssignDesksToTeamDialog } from "@features/whereabouts/pages/company-movements/dialogs/AssignDesksToTeamDialog";
import { AssignDesksToIndividualDialog } from "@features/whereabouts/pages/company-movements/dialogs/AssignDesksToIndividualDialog";
import { AssignDesksToWorkgroupDialog } from "@features/whereabouts/pages/company-movements/dialogs/AssignDesksToWorkgroupDialog";
import { DeleteMeetingRoomConfirmDialog } from "@features/meeting-rooms/pages/dialogs/DeleteMeetingRoomConfirmDialog";
import { ResetDesksDialog } from "@features/meeting-rooms/pages/dialogs/ResetDesksDialog";
import AddTeamDialog from '@shared/dialogs/add-team-dialog/AddTeamDialog';
import {
  LinkTeamOrWorkgroupToOfficeDialog
} from "@features/whereabouts/pages/company-movements/dialogs/LinkTeamOrWorkgroupToOfficeDialog";
import { NewUserOnboardingDialog } from '@shared/dialogs/new-user-onboarding-dialog/NewUserOnboardingDialog';
import ChangeOfficeDialog from "@features/whereabouts/pages/company-movements/dialogs/ChangeOfficeDialog";
import ChangeCalendarDateDialog from "@features/whereabouts/pages/company-movements/dialogs/ChangeCalendarDateDialog";
import { EditCarParkingSpaceDialog } from '@shared/dialogs/car-parking-plan-dialogs/EditCarParkingSpaceDialog';
import { AddVisitorDialog } from "@features/whereabouts/pages/company-movements/components/visitor-booking/AddVisitorDialog";
import { EditDepartmentDialog } from "@features/whereabouts/pages/departments/EditDepartmentDialog";
import AddDepartmentMembersDialog from "@features/settings/pages/department-management-page/dialogs/AddDepartmentMembersDialog";
import AddTeamMemberDialog from "@features/settings/pages/manage-users-page-v2/dialogs/AddTeamMemberDialog";
import { UnableToBookDesksErrorDialog } from '@shared/dialogs/saved-whereabouts-errors/UnableToBookDesksErrorDialog';
import { CannotEditApprovedHoliday } from '@shared/dialogs/saved-whereabouts-errors/CannotEditApprovedHoliday';
import AssignToDepartmentDialog from "@features/settings/pages/manage-users-page-v2/dialogs/AssignToDepartmentDialog";
import { SelectLeaveTypeDialog } from '@shared/dialogs/SelectLeaveTypeDialog';
import { CancelApprovedLeaveDialog } from "@features/holidays/pages/approvals/dialogs/CancelApprovedLeaveDialog";
import { UsageLimitReachedDialog } from '@shared/dialogs/usage-limit-dialog/UsageLimitReachedDialog';
import { SideOfDaySelectorDialog } from '@shared/dialogs/side-of-day-dialog/SideOfDaySelectorDialog';
import {
  VisitorBookingFilterDialog
} from "@features/whereabouts/pages/company-movements/components/visitor-booking/VisitorBookingFilterDialog";
import { DayNotesEntryDialog } from '@shared/dialogs/DayNotesEntryDialog';
import { WhereaboutsOptionPickerDialog } from '@shared/dialogs/WhereaboutsOptionPickerDialog';
import {
  HolidayRollOverConfirmationDialog
} from "@features/holidays/pages/carry-over/HolidayRollOverConfirmationDialog";
import {
  HospitalityCreateOrderItemDialog
} from "@features/settings/pages/office-management-page-v2/components/HospitalityCreateOrderItemDialog";
import {
  MeetingRoomBookingDialogV2
} from "@features/meeting-rooms/pages/meeting-room-booking-dialog-v2/MeetingRoomBookingDialogV2";
import {
  HospitalityEditImportantNoteDialog
} from "@features/settings/pages/office-management-page-v2/components/HospitalityEditImportantNoteDialog";
import {
  FollowTeamsAndWorkgroupsDialog
} from "@shared/dialogs/FollowTeamsAndWorkgroupsDialog";
import WelcomeDialog from "@shared/dialogs/welcome-dialog/WelcomeDialog";
import PermissionNeededDialog from "@shared/dialogs/permission-needed-dialog/PermissionNeededDialog";
import DeleteTeamDialog from "@shared/dialogs/delete-team-dialog/DeleteTeamDialog";
import DeleteCompanyDialog from "@shared/dialogs/delete-company-dialog/DeleteCompanyDialog";
import SetupCompanyDialog from "@shared/dialogs/setup-company-dialog/SetupCompanyDialog";
import NewPaymentDialog from "@shared/dialogs/NewPaymentDialog";
import DeleteUserDialog from "@shared/dialogs/delete-user-dialog/DeleteUserDialog";
import UserSearchDialog from "@shared/dialogs/user-search-dialog/UserSearchDialog";
import { AddProjectOrEventDialog } from "@shared/dialogs/add-project-or-event-dialog/AddProjectOrEventDialog";
import { ChangePlanConfirmDialog } from "@features/settings/pages/payments-page/ChangePlanConfirmDialog";
import { ManageSubscriptionDialog } from "@features/settings/pages/payments-page/ManageSubscriptionDialog";
import { UpgradeContactDialog } from "@features/settings/pages/payments-page/UpgradeContactDialog";


export function DynamicDialogRenderer() {
  const activeDialog = useSelector(selectActiveDialog);
  const scrollPosition = useSelector(selectScrollPosition);
  const payload = useSelector(selectPayload);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!activeDialog && scrollPosition) {
      window.scrollTo(0, scrollPosition);
      dispatch(setScrollPosition(null));
    }
  }, [dispatch, scrollPosition, activeDialog]);

  switch (activeDialog) {
    case DialogIdentifiers.StripeSuccess:
      return <StripeSuccessDialog/>;
    case DialogIdentifiers.StripeFailure:
      return <StripeFailedDialog/>;
    case DialogIdentifiers.ChooseLocation:
      return <ChooseLocationDialog payload={payload} />;
    case DialogIdentifiers.SignUpTermsDialog:
      return <SignUpTermsDialog/>;
    case DialogIdentifiers.CreateTagDialog:
      return <CreateTagDialog payload={payload}/>;
    case DialogIdentifiers.EditTagDialog:
      return <EditTagDialog payload={payload}/>;
    case DialogIdentifiers.WhereaboutsModifiedDialog:
      return <WhereaboutsModifiedDialog/>;
    case DialogIdentifiers.AddCustomWhereabouts:
      return <AddCustomWhereaboutsDialog/>;
    case DialogIdentifiers.DeleteOfficeEntityDialog:
      return <DeleteOfficeEntityDialog payload={payload}/>;
    case DialogIdentifiers.DeleteDeskEntityDialog:
      return <DeleteDeskEntityDialog payload={payload}/>;
    case DialogIdentifiers.AzureCalendarSyncDisabledDialog:
      return <AzureCalendarSyncDisabledDialog />;
    case DialogIdentifiers.EditDeskDialog:
      return <EditDeskDialog payload={payload} />;
    case DialogIdentifiers.EditUsersInTagDialog:
      return <EditUsersInTagDialog payload={payload} />;
    case DialogIdentifiers.ManageFavouritesDialog:
      return <ManageFavouritesDialog />;
    case DialogIdentifiers.WeeklyNotes:
      return <WeeklyNotesDialog payload={payload} />;
    case DialogIdentifiers.AzurePermissionsRequired:
      return <AzurePermissionsRequired />;
    case DialogIdentifiers.BookMeetingRoom:
      return <MeetingRoomBookingDialog payload={payload} />;
    case DialogIdentifiers.BookMeetingRoomV2:
      return <MeetingRoomBookingDialogV2 payload={payload} />;
    case DialogIdentifiers.EditBookMeetingRoom:
      return <EditMeetingRoomBookingDialog payload={payload} />;
    case DialogIdentifiers.AdvanceMeetingRoomBookingDialog:
      return <AdvanceMeetingRoomBookingDialog payload={payload} />;
    case DialogIdentifiers.RepeatScheduleDialog:
      return <RepeatScheduleDialog payload={payload} />;
    case DialogIdentifiers.SavedWhereaboutsErrors:
      return <SavedWhereaboutsErrors payload={payload} />;
    case DialogIdentifiers.AssignToOffice:
      return <AssignToOfficeDialog payload={payload} />;
    case DialogIdentifiers.AssignToTeam:
      return <AssignToTeamDialog payload={payload} />;
    case DialogIdentifiers.AssignToDepartment:
      return <AssignToDepartmentDialog payload={payload} />;
    case DialogIdentifiers.AssignToWorkgroup:
      return <AssignToWorkGroupDialog payload={payload} />;
    case DialogIdentifiers.AddMultipleUsersInfo:
      return <AddMultipleUsersDialog />;
    case DialogIdentifiers.EditTagNameDialog:
      return <EditTagNameDialog payload={payload} />;
    case DialogIdentifiers.AddUserToWorkGroupsDialog:
      return <AddUserToWorkGroupsDialog payload={payload} />;
    case DialogIdentifiers.AssignDesksToTeam:
      return <AssignDesksToTeamDialog />;
    case DialogIdentifiers.AssignDesksToIndividual:
      return <AssignDesksToIndividualDialog />;
    case DialogIdentifiers.AssignDesksToWorkgroup:
      return <AssignDesksToWorkgroupDialog />;
    case DialogIdentifiers.DeleteMeetingRoomConfirm:
      return <DeleteMeetingRoomConfirmDialog payload={payload} />;
    case DialogIdentifiers.ResetDesks:
      return <ResetDesksDialog />;
    case DialogIdentifiers.CreateTeamDialog:
      return <AddTeamDialog />;
    case DialogIdentifiers.LinkTeamOrGroupToOfficeDialog:
      return <LinkTeamOrWorkgroupToOfficeDialog />;
    case DialogIdentifiers.NewUserOnboardingDialog:
      return <NewUserOnboardingDialog />;
    case DialogIdentifiers.ChangeOfficeDialog:
      return <ChangeOfficeDialog />;
    case DialogIdentifiers.ChangeCalendarDateDialog:
      return <ChangeCalendarDateDialog />;
    case DialogIdentifiers.EditParkingSpaceDialog:
      return <EditCarParkingSpaceDialog payload={payload} />;
    case DialogIdentifiers.AddVisitorDialog:
      return <AddVisitorDialog payload={payload} />;
    case DialogIdentifiers.EditDepartmentDialog:
      return <EditDepartmentDialog payload={payload} />;
    case DialogIdentifiers.UnableToBookDesksErrorDialog:
      return <UnableToBookDesksErrorDialog payload={payload} />;
    case DialogIdentifiers.CannotEditApprovedHoliday:
      return <CannotEditApprovedHoliday />;
    case DialogIdentifiers.SelectLeaveTypeDialog:
      return <SelectLeaveTypeDialog payload={payload} />;
    case DialogIdentifiers.CancelApproveLeaveDialog:
      return <CancelApprovedLeaveDialog payload={payload} />;
    case DialogIdentifiers.UsageLimitReachedDialog:
      return <UsageLimitReachedDialog payload={payload} />;
    case DialogIdentifiers.SideOfDaySelectorDialog:
      return <SideOfDaySelectorDialog payload={payload} />;
    case DialogIdentifiers.VisitorBookingFilterDialog:
      return <VisitorBookingFilterDialog />;
    case DialogIdentifiers.DayNotesEntryDialog:
      return <DayNotesEntryDialog payload={payload} />;
    case DialogIdentifiers.WhereaboutsOptionPickerDialog:
      return <WhereaboutsOptionPickerDialog payload={payload} />;
    case DialogIdentifiers.HolidayRollOverConfirmationDialog:
      return <HolidayRollOverConfirmationDialog payload={payload} />;
    case DialogIdentifiers.HospitalityCreateOrderItemDialog:
      return <HospitalityCreateOrderItemDialog payload={payload} />;
    case DialogIdentifiers.HospitalityEditImportantNote:
      return <HospitalityEditImportantNoteDialog payload={payload} />;
    case DialogIdentifiers.FollowTeamsAndWorkgroupsDialog:
      return <FollowTeamsAndWorkgroupsDialog />;
    case DialogIdentifiers.WelcomeDialog:
      return <WelcomeDialog />;
    case DialogIdentifiers.PermissionNeededDialog:
      return <PermissionNeededDialog payload={payload} />;
    case DialogIdentifiers.DeleteTeamDialog:
      return <DeleteTeamDialog payload={payload} />;
    case DialogIdentifiers.DeleteCompanyDialog:
      return <DeleteCompanyDialog payload={payload} />;
    case DialogIdentifiers.SetupCompanyDialog:
      return <SetupCompanyDialog />;
    case DialogIdentifiers.NewPaymentDialog:
      return <NewPaymentDialog />;
    case DialogIdentifiers.DeleteUserDialog:
      return <DeleteUserDialog payload={payload} />;
    case DialogIdentifiers.UserSearchDialog:
      return <UserSearchDialog payload={payload} />;
    case DialogIdentifiers.AddProjectOrEventDialog:
      return <AddProjectOrEventDialog />;
    case DialogIdentifiers.ChangePlanConfirmDialog:
      return <ChangePlanConfirmDialog payload={payload} />;
    case DialogIdentifiers.ManageSubscription:
      return <ManageSubscriptionDialog />;
    case DialogIdentifiers.UpgradeContactDialog:
      return <UpgradeContactDialog payload={payload} />;
    case DialogIdentifiers.AddDepartmentMembers:
      return <AddDepartmentMembersDialog payload={payload} />;
    case DialogIdentifiers.AddTeamMemberDialog:
      return <AddTeamMemberDialog payload={payload} />;
    default:
      return null;
  }
}
